import { render } from "./RegistroLecturaContador.vue?vue&type=template&id=2ea76434&scoped=true"
import script from "./RegistroLecturaContador.vue?vue&type=script&lang=js"
export * from "./RegistroLecturaContador.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea76434"]])

export default __exports__